import React from "react";

import { Money } from "../Money";
import { IProps } from "./types";

import { ShopContext } from "../../../../components/ShopProvider/context";

export const TaxedMoney: React.FC<IProps> = ({
  taxedMoney,
  defaultValue,
  overrideDisplayGrossPrices,
  ...props
}: IProps) => {
  let { displayGrossPrices } = React.useContext(ShopContext);
  if (overrideDisplayGrossPrices) {
    displayGrossPrices = !displayGrossPrices
  }
  const money = taxedMoney
    ? displayGrossPrices
      ? taxedMoney.gross
      : taxedMoney.net
    : undefined;
  return <Money {...props} money={money} defaultValue={defaultValue} />;
};

TaxedMoney.displayName = "TaxedMoney";
export default TaxedMoney;
